import fire from './Firebase';
import { getFirestore} from "firebase/firestore";

const db=getFirestore(fire)

export default db